import { Link } from "@/lib/router-compat";
import { MapPin } from "lucide-react";

export const SERVICE_AREA_LINKS: Record<string, string> = {
  "Cherry Hill": "/iop-cherry-hill-nj",
  "Camden": "/addiction-treatment-camden-nj",
  "Voorhees": "/addiction-treatment-voorhees-nj",
  "Marlton": "/addiction-treatment-marlton-nj",
  "Moorestown": "/addiction-treatment-moorestown-nj",
  "Haddonfield": "/addiction-treatment-haddonfield-nj",
  "Mount Laurel": "/addiction-treatment-mount-laurel-nj",
  "Medford": "/addiction-treatment-medford-nj",
  "Evesham": "/addiction-treatment-marlton-nj",
  "Pennsauken": "/addiction-treatment-pennsauken-nj",
  "Cinnaminson": "/addiction-treatment-cinnaminson-nj",
  "Turnersville": "/addiction-treatment-turnersville-nj",
  "Sewell": "/addiction-treatment-sewell-nj",
  "Washington Township": "/addiction-treatment-washington-township-nj",
  "Glassboro": "/addiction-treatment-glassboro-nj",
  "Burlington County": "/addiction-treatment-burlington-county-nj",
  "Camden County": "/addiction-treatment-camden-county-nj",
  "All of NJ (Virtual IOP)": "/virtual-iop-new-jersey",
  "All of New Jersey": "/virtual-iop-new-jersey",
};

export const DEFAULT_SERVICE_AREAS = [
  "Cherry Hill", "Camden", "Voorhees", "Marlton", "Moorestown",
  "Haddonfield", "Mount Laurel", "Medford", "Evesham", "Pennsauken",
  "Burlington County", "Gloucester County", "Atlantic County",
  "Philadelphia Area", "All of NJ (Virtual IOP)",
];

const baseStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  background: "#FFFFFF",
  border: "1px solid #F0E0E0",
  borderRadius: 50,
  padding: "8px 16px",
  color: "#8B1A1A",
  fontWeight: 700,
  fontSize: 14,
  lineHeight: 1.2,
  textDecoration: "none",
};

export const ServiceAreaPill = ({
  name,
  href,
}: {
  name: string;
  href?: string | undefined;
}) => {
  if (href) {
    return (
      <Link to={href} style={baseStyle} className="hover:bg-[#FAF4F0] transition-colors focus:outline-hidden focus:ring-2 focus:ring-secondary">
        {name}
      </Link>
    );
  }
  return <span style={baseStyle}>{name}</span>;
};

interface ServiceAreaPillsProps {
  areas?: string[];
  className?: string;
  style?: React.CSSProperties;
  linkable?: boolean;
}

const ServiceAreaPills = ({
  areas = DEFAULT_SERVICE_AREAS,
  className = "flex flex-wrap gap-2",
  style,
  linkable = true,
}: ServiceAreaPillsProps) => (
  <div className={className} style={style}>
    {areas.map((name) => {
      const href = linkable ? SERVICE_AREA_LINKS[name] : undefined;
      return <ServiceAreaPill key={name} name={name} href={href} />;
    })}
  </div>
);

export default ServiceAreaPills;

// Themed variant matching the shadcn ServiceArea section (with MapPin icon)
export const ServiceAreaThemedPills = ({ areas = DEFAULT_SERVICE_AREAS }: { areas?: string[] }) => (
  <div className="flex flex-wrap gap-3">
    {areas.map((a) => {
      const href = SERVICE_AREA_LINKS[a];
      const cls = "inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-card border border-border text-sm font-medium text-foreground/80 hover:border-secondary hover:text-secondary transition-colors";
      if (href) {
        return (
          <Link key={a} to={href} className={cls}>
            <MapPin className="h-3.5 w-3.5 text-secondary" /> {a}
          </Link>
        );
      }
      return (
        <span key={a} className={cls}>
          <MapPin className="h-3.5 w-3.5 text-secondary" /> {a}
        </span>
      );
    })}
  </div>
);
